<template>
  <v-list dense class="pt-0">
    <v-list-tile v-for="item in sideMenuItems" :key="item.title" :to="{name: item.target}" exact>
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'ConfigMenu',
  data: () => ({
    sideMenuItems: [
      { title: 'Общие настройки', icon: 'lightbulb_outline', target: 'configCommon' },
      // { title: 'Список проверяющих', icon: 'lightbulb_outline', target: 'configUsers' },
      { title: 'Права проверяющих', icon: 'lightbulb_outline', target: 'configRoles' }
    ]
  })
}
</script>
